import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSHeader from 'designSystem/components/PDSHeader/PDSHeader'
import PDSSeparator from 'designSystem/components/PDSSeparator/PDSSeparator'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  onClose: () => void
  showModal: boolean
}

export default function ProjectedFundamentalsInfoModal({
  onClose,
  showModal,
}: Props) {
  return (
    <>
      <Modal isCentered isOpen={showModal} onClose={onClose} size="sm">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <PDSHeader variant="h4">Projected Fundamentals</PDSHeader>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <PDSBox display="grid" gap={SIZE.s24}>
              <PDSText>
                All references to dividends, yield, valuation metrics, or income
                potential are based on current holdings, prices, and market
                conditions. These are subject to change without notice. Dividend
                payments are not guaranteed and may fluctuate based on the
                underlying security.
              </PDSText>
              <PDSText>
                Data, projections, and labels used in investment portfolio
                materials are forward-looking in nature and reflect current
                expectations, estimates, and assumptions. Forward-looking
                statements can be uncertain and are subject to risks, changes in
                circumstances, and other factors that may cause actual outcomes
                to differ. Past performance is not indicative of future results.
                Investors and financial professionals should consider the
                account circumstances before making investment decisions related
                to the specific account.
              </PDSText>
            </PDSBox>
          </ModalBody>
          <PDSSeparator marginTop={SIZE.s16} />
          <ModalFooter paddingTop={SIZE.s12}>
            <PDSFlexBox width="100%" margin={SIZE.s16}>
              <PDSButton
                onClick={onClose}
                size="md-f"
                text="Close"
                variant="tertiary"
              />
            </PDSFlexBox>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
